import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { Theme } from '@astryxdesign/core/theme'
import { stoneTheme } from '@astryxdesign/theme-stone/built'
import { routeTree } from './routeTree.gen'
import { startSync } from './lib/sync'
import { initDisplay, useDisplay } from './lib/display'
import './styles.css'

const router = createRouter({ routeTree, defaultPreload: 'intent' })

declare module '@tanstack/react-router' {
  interface Register { router: typeof router }
}

startSync()
// Before the first paint, so a phone set to 130% never flashes at 100%.
initDisplay()

/**
 * Theme's mode is a prop, so the switch in Accessibility has to re-render the
 * provider. 'system' still means system — this only adds the two explicit
 * choices on top of it.
 */
function Themed() {
  const { mode } = useDisplay()
  return (
    <Theme theme={stoneTheme} mode={mode}>
      <RouterProvider router={router} />
    </Theme>
  )
}

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(console.error)
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Themed />
  </StrictMode>,
)
